export default {
  sm: `
  LEED 인증은 건물의 입지 선정부터 설계, 건축, 
  운영까지 건축의 전 과정에서 얼마나 친환경적인 
  노력을 기울였는지를 평가하는 세계적인 친환경 건물 인증 제도입니다.
  `,
  md: `
  LEED 인증은 건물의 입지 선정부터 설계, 건축, 운영까지 건축의 전 과정에서 얼마나 친환경적인 노력을 기울였는지를 평가하는 세계적인 친환경 건물 인증 제도입니다.
  `
};
